<ng-container *ngIf="token">
<div
  style="
    background-color: black;
    width: 100%;
    height: 6vh;
    padding: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
  "
>
  <img src="../../assets/img/{{token.company.logoName}}" alt="" style="height: 5vh" />
</div>
<div
  style="
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  "
>
  <div style="width: 90vw; height: 95vh" class="p-4 mt-20 bg-white rounded-lg shadow-lg">
    <div class="mb-3 page-title-box d-sm-flex align-items-center justify-content-between">
      <b class="text-2xl">Welcome to {{ token.company.name }} !</b>
    </div>

    <!-- Loading -->
    <div *ngIf="step === 'loading'" class="flex items-center justify-center h-full">
      <h1 class="text-2xl">Verifying status</h1>
      <div>
        <app-spinner></app-spinner>
      </div>
    </div>

    <!-- Step 1: ID Screening -->
    <div *ngIf="step === 'id-screening'">
      <div *ngIf="button">
        <div class="ml-2">
          <div class="w-full">
            <p class="my-2 ml-10 text-lg">
              To continue your employment onboarding, we need to verify your identity with a government-issued ID. Please
              select the type of identification document you will upload.
            </p>
          </div>
          <div>
            <label class="text-lg font-bold" id="document-type-group-label"
              >Choose the type of identification document you will be uploading:</label
            >
            <div style="color: rgb(218, 0, 0)" class="text-lg errormsg">{{ errorData }}</div>
            <mat-radio-group [(ngModel)]="selectedDocumentType" (change)="onSelectDocumentType($event)" color="accent">
              <div class="ml-10 radio-buttons-row">
                <mat-radio-button
                  [value]="documentType.value"
                  *ngFor="let documentType of documentTypes"
                  style="margin-top: 5px; margin-bottom: 5px;"
                  class="text-lg"
                >
                  {{ documentType.label }}
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div *ngIf="button" class="flex flex-col w-full mt-2">
        <i class="text-lg"
          >Note: If you do not have one of these forms of identification, please contact your human resources.</i
        >
        <p style="margin-top: 10px" class="text-lg">
          After selecting your ID type, click the button below to upload your document and complete a quick facial scan
          for verification.
        </p>
        <div class="flex justify-center w-full">
          <button class="px-5 py-2 text-lg Verfy_show_btn" (click)="openPopup()">Verify your identity</button>
        </div>
      </div>
      <div
        *ngIf="button === false"
        style="
          width: 80vw;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <p *ngIf="!button && !successfull" class="text-2xl textp">
          Please scan the QR code to submit your {{ selectedDocumentType }} document.
        </p>
      </div>
      <div *ngIf="button === false" class="frame-container">
        <iframe
          (loadend)="onLoaded()"
          class="frame"
          *ngIf="link"
          [src]="link"
          allow="fullscreen *;camera *;encrypted-media *;"
          width="100%"
          height="800vh"
        >
        </iframe>
      </div>
      <div *ngIf="!button && !successfull" class="datashown">
        <button class="px-5 py-2 text-lg Verfy_show_btn" (click)="backToPage()">Back to Change Document Type</button>
      </div>
      <div *ngIf="!button && !successfull" style="width: 100%; display: flex; justify-content: center" class="mt-4">
        <img src="../../assets/img/{{token.company.logoName}}" alt="" style="height: 8vh" />
      </div>
    </div>

    <!-- Step 2: Disclosure Signing -->
    <div *ngIf="step === 'disclosure-signing'" class="flex flex-col" style="height: 75vh">
      <p class="text-lg">
        To continue your onboarding, we need you to review and sign the necessary disclosures. Please complete this step to
        proceed.
      </p>
      <div *ngIf="!signingUrl" class="flex-col p-4 my-3 border rounded-lg shadow-lg simple-form">
        <label><b>Full Name</b><input type="text" class="p-2 mx-2 border" [(ngModel)]="signerName" /></label>
        <label><b>SSN</b><input type="text" class="p-2 mx-2 border" [(ngModel)]="signerSSN" /></label>
        <button (click)="createDocument()" [disabled]="!signerName || !validSSN()" [class]="getViewDocumentClass()">View Document</button>
      </div>
      <iframe *ngIf="signingUrl" width="100%" height="100%" class="frame" [src]="signingUrl" allow="fullscreen *;camera *;encrypted-media *;"></iframe>
    </div>

    <!-- Done -->
    <div *ngIf="step === 'done'" class="flex flex-col items-center justify-center w-full h-full">
      <div class="flex items-center justify-center bg-green-500 rounded-full w-52 h-52">
        <app-svg-icons [iconName]="'successfull'"></app-svg-icons>
      </div>
      <div class="flex flex-col items-center justify-center text-2xl h-96">
        <h1>Your onboarding process is complete.</h1>
        <h1>Thank you for your submission.</h1>
      </div>
      <div style="width: 100%; display: flex; justify-content: center" class="mt-4">
        <img src="../../assets/img/{{token.company.logoName}}" alt="" style="height: 8vh" />
      </div>
    </div>
  </div>
</div>
</ng-container>
<div *ngIf="isPopupOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
  <div class="w-auto h-auto bg-white rounded-lg">
    <div class="flex verify img h-4/6">
      <div class="m-2">
        <p class="ml-4 text-xl font-bold">Step 1:</p>
        <img src="/assets/img/idv1.png" class="h-72" alt="" />
      </div>
      <div class="m-2">
        <p class="text-xl font-bold">Step 2:</p>
        <img src="/assets/img/idv3.png" class="h-72" alt="" />
      </div>
      <div class="m-2">
        <p class="text-xl font-bold">Step 3:</p>
        <img src="/assets/img/idv2.png" class="h-64" alt="" />
      </div>
    </div>
    <div class="ml-5 helptext">
      <h1 class="text-lg font-bold">Tips:</h1>
      <ul>
        <li>Place the Green Box around your ID, once it's accepted, the image will be collected.</li>
        <li>Place the ID on a flat surface so it's stable.</li>
      </ul>
    </div>
    <div class="flex items-center justify-center w-full m-2">
      <button class="px-5 py-2 text-lg Verfy_show_btn_cancel" (click)="cancelBtn()">Cancel</button>
      <button class="px-5 py-2 text-lg Verfy_show_btn" (click)="confirmVerify()">Next</button>
    </div>
  </div>
</div>
